import { configurationService } from '../../helpers/services/configuration.service';
import Swal from "sweetalert2";
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    status: {},
    details: {},
}
export const CONFIGURATION_MODULE = 'configuration';

// define action 
export const GET_ALL_CONFIGURATION = 'getAllConfiguration';
export const GET_CONFIGURATION = 'getConfiguration';
export const UPDATE_CONFIGURATION = 'updateConfiguration';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const UPDATE_CONFIGURATION_SUCCESS = "updateConfigurationSuccess";
const GET_ALL_CONFIGURATION_REQUEST = "getAllConfigurationRequest";
const GET_CONFIGURATION_REQUEST = "getConfigurationRequest";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_CONFIGURATION]({ dispatch, commit }, { filter }) {
        configurationService
            .getAllConfiguration(filter)
            .then(
                (result) => {
                    commit(GET_ALL_CONFIGURATION_REQUEST, result)
                },
                (error) => {
                    if (error.alertMessage) {
                        Swal.fire(i18n.t('message.error'), error.alertMessage, 'error');
                    }
                    else {
                        var errorMessage = i18n.t("message.unknownError");
                        Swal.fire(i18n.t('message.error'), errorMessage, 'error');
                    }
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_CONFIGURATION]({ commit, dispatch }, { key }) {
        configurationService
            .getConfiguration(key)
            .then(
                (result) => {
                    commit(GET_CONFIGURATION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_CONFIGURATION]({ commit, dispatch }, { data }) {
        commit(REQUEST)
        if ((data.valueType === 'image' || data.valueType === 'imageArray') && (data.value != null && typeof(data.value) === 'string')) {
            let message = i18n.t("message.updateXSuccess", [i18n.t('module.configuration')]);
            sharedHelper.alertSuccessMessage(message)
            commit(UPDATE_CONFIGURATION_SUCCESS);
        }
        else {
            configurationService
                .updateConfiguration(data)
                .then(
                    // eslint-disable-next-line no-unused-vars
                    (result) => {
                        let message = i18n.t("message.updateXSuccess", [i18n.t('module.configuration')]);
                        sharedHelper.alertSuccessMessage(message)
                        commit(UPDATE_CONFIGURATION_SUCCESS);
                    },
                    (error) => {
                        let message = sharedHelper.getErrorMessage(error);
                        sharedHelper.alertErrorMessage(message, error.response.data.code)
                        commit(FAILURE);
                    }
                )
        }
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true };
    },
    [UPDATE_CONFIGURATION_SUCCESS](state) {
        state.status = {};
        router.push({ name: "Configuration-listing" })
    },
    [GET_ALL_CONFIGURATION_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                key: o.key,
                value: o.value,
                isActive: o.is_active,
                valueType: o.value_type,
            }
        })
    },
    [GET_CONFIGURATION_REQUEST](state, data) {
        let o = data.data

        state.details = {
            key: o.key,
            value: o.value,
            isActive: o.is_active,
            valueType: o.value_type,
        }
    }
}


